import { EuiFlexItem } from "@elastic/eui";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useParams } from "react-router";

import { isPortrait } from "../utils/PricelistUtils";
import { Badge } from "./Badge";
import {
    deSteegLegend,
    easyGoingLegend,
    easyGoingVerticalLegend,
    maryJaneLegend,
    maryJaneVerticalLegend,
    mississippiLegend,
    mississippiVerticalLegend,
    missouriLegend,
    missouriVerticalLegend,
    roundAboutLegend,
    roundAboutLegendVertical,
} from "./LegendStyling";
import {
    easyGoingBadges,
    easyGoingBadgesVertical,
    maryJaneBadges,
    maryJaneBadgesVertical,
    mississippiBadges,
    mississippiBadgesVertical,
} from "./PriceRowStyling";

export const PriceLegend = (props) => {
    const { shopId, screenId } = useParams();

    const stylesRow = (() => {
        switch (shopId) {
            case "bbc0cfa7-e230-4338-817a-55190debdac0":
                return isPortrait ? maryJaneBadgesVertical : maryJaneBadges;
            case "ddd70853-5e9d-45ff-82b3-24c9d81d4e32":
                return isPortrait ? easyGoingBadgesVertical : easyGoingBadges;
            case "a08a13e2-a31b-4b6d-b2b4-0491cb3d2227":
                return isPortrait ? mississippiBadgesVertical : mississippiBadges;
            default:
                return isPortrait ? mississippiBadgesVertical : mississippiBadges;
        }
    })();

    const styles = (() => {
        switch (shopId) {
            case "bbc0cfa7-e230-4338-817a-55190debdac0":
                if (screenId) return {};
                return isPortrait ? maryJaneVerticalLegend : maryJaneLegend;
            case "ddd70853-5e9d-45ff-82b3-24c9d81d4e32":
                if (screenId) return {};
                return isPortrait ? easyGoingVerticalLegend : easyGoingLegend;
            case "a08a13e2-a31b-4b6d-b2b4-0491cb3d2227":
                if (screenId) return {};
                return isPortrait ? missouriVerticalLegend : missouriLegend;
            case "470f3f5a-e7b9-43a5-bbfd-2ffce8c161e4":
                if (screenId) return {};
                return deSteegLegend;
            case "f155b35a-14a1-4866-867f-93fe21e9769b":
                return isPortrait ? roundAboutLegendVertical : roundAboutLegend;
            default:
                if (screenId) return {};
                return isPortrait ? mississippiVerticalLegend : mississippiLegend;
        }
    })();

    return (
        <EuiFlexItem css={styles}>
            <div className="legend">
                <div className="container">
                    <div className="content">
                        <div className="legendRow">
                            <div className="newIcon">
                                <FontAwesomeIcon
                                    style={{
                                        marginLeft: "0.5vw",
                                        fontSize: "1.5vw",
                                    }}
                                    icon={faStar}
                                    color={"#d1cb28"}
                                />
                            </div>
                            <div className="label">New</div>
                        </div>
                        <div className="legendRow">
                            <div style={{ fontSize: "1.5vw" }}>🔥</div>
                            <div className="label">Strong</div>
                        </div>
                        <div className="legendRow legendBadge">
                            <Badge letter={"c"} styles={stylesRow} />
                            <div className="label">CBD</div>
                        </div>
                        <div className="legendRow legendBadge">
                            <Badge letter={"i"} styles={stylesRow} />
                            <div className="label">Indica</div>
                        </div>

                        <div className="legendRow legendBadge">
                            <Badge letter={"s"} styles={stylesRow} />
                            <div className="label">Sativa</div>
                        </div>
                        <div className="legendRow legendBadge">
                            <Badge letter={"h"} styles={stylesRow} />
                            <div className="label">Hybrid</div>
                        </div>
                    </div>
                </div>
            </div>
        </EuiFlexItem>
    );
};
